<template>
  <div class="screener-results">
    <v-overlay :value="loading" z-index="4">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-container>
      <v-row>
        <v-col cols="12">
          <main-user-table
            v-if="!screener"
            :headers="headers"
            :items="screenerTemplatesParticipants"
            :items-per-page="queryParams.pageSize"
            :server-items-length="pagination.totalCount || -1"
            :page="queryParams.page"
            :row-component="'patient-screeners-table-row'"
            @to-screener="toScreener"
            @action:get-data="getDataAction"
          />
          <screener-content v-else
            :screener="screener"
            :screener-progress="screenerProgress"
            @back="back"
            @toScreener="toScreener"
          />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import MainUserTable from "@/components/tables/MainUserTable"
import RouterMixin from "@/mixins/router"
import ScreenerContent from '@/components/screeners/ScreenerContent.vue'
import { debounce } from "@/helpers/debounce"

export default {
  name: "ScreenerResults",
  components: {
    MainUserTable,
    ScreenerContent,
  },
  mixins: [RouterMixin],
  data () {
    return {
      headers: [
        { sortable: false },
        { text: 'Name', value: 'name', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Sent date', value: 'creationDate', sortable: false },
        { text: 'Completed date', value: 'endDate', sortable: false},
        { text: 'Score', value: 'score', sortable: false },
      ],
      currentParticipant: null,
      defaultQueryParams: {
        pageSize: 50,
        surveyDefinition: this.$route.params.id
      },
    }
  },
  computed: {
    ...mapState('screenersStates', [
      'screenerTemplatesParticipants',
      'pagination',
    ]),
    ...mapState('patientsStates', [
      'screener',
      'screenerProgress',
      'loading',
    ]),
    userId () {
      return this.$route.params.id
    },
    creationDate () {
      return this.$moment(this.screener.creationDate).format("MMMM Do, YYYY")
    },
  },
  methods: {
    ...mapActions('screenersStates', [
      'getScreenerTemplateParticipants',
    ]),
    ...mapActions('patientsStates', [
      'getScreener',
      'getScreenerProgress',
    ]),
    ...mapMutations('patientsStates', [
      'setScreener',
      'setScreenerProgress',
    ]),
    getData (data) {
      debounce(() => {
        this.getScreenerTemplateParticipants(data)
      }, 100, 'getScreenerTemplateParticipants')
    },
    toScreener(id, participantId) {
      if (participantId) this.currentParticipant = participantId
      debounce(()=>{
        this.getScreener({participantId: participantId ||  this.currentParticipant, screenerId: id}).then((screener)=>{
        })
        this.getScreenerProgress({participantId: participantId || this.currentParticipant, screenerId: id})
      },100)
    },
    back() {
      this.currentParticipant = null
      this.setScreener(null)
      this.setScreenerProgress(null)
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";

.screener-results {
  padding:32px;
  &--wrap {
    display: flex;
  }

  &-sidebar {
    width: 272px;
    padding: 24px;

    textarea:not([readonly]) {
      padding: 4px;
    }
  }

  &-action-btn {
    cursor: pointer;
    font-weight: 600;
  }

  &-field {
    margin-bottom: $gutter;
  }
}
</style>
